import script from "./Pre-Engagement-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Pre-Engagement-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Pre-Engagement-Questionnaire-Main.vue?vue&type=style&index=0&id=3d7b1a94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7b1a94"]])

export default __exports__